export default __webpack_public_path__ + "assets/static/data/app-data.53751184ef8ede3aad98ffbb1e6f6d98.json";